export const AppointmentDecisionVI = {
    "appointmentDecision": {
        "heading": {
            "addAppointment" : "Tạo mới quyết định bổ nhiệm",
            "detailAppointment" : "Chi tiết quyết định bổ nhiệm",
            "updateAppointment" : "Cập nhật quyết định bổ nhiệm",
            "generalInformation" : "Thông tin chung"
        },
        "label":{
            "department": "Phòng ban bổ nhiệm",
            "jobPosition" : "Vị trí bổ nhiệm",
            "jobTitle" : "Chức vụ bổ nhiệm"
        },
        "placeholder":{
            "department": "Chọn phòng ban",
            "jobPosition" : "Chọn vị trí",
            "jobTitle" : "Chọn chức vụ"
        },
        "message" : {
            "department": "Vui lòng chọn phòng ban bổ nhiệm",
            "jobPosition" : "Vui lòng chọn vị trí bổ nhiệm",
            "jobTitle" : "Vui lòng chọn chức vụ bổ nhiệm"
        },
        "detail": {
            "currentDepartment": "Phòng ban cũ",
            "currentJobPosition" : "Vị trí cũ",
            "currentJobTitle" : "Chức vụ cũ",
            "appointDepartment": "Phòng ban bổ nhiệm",
            "appointJobPosition" : "Vị trí bổ nhiệm",
            "appointJobTitle" : "Chức vụ bổ nhiệm",
        }
    }
}